module.exports = __webpack_public_path__ + "img/background-rules.917b823d.svg";